import Header from '@/components/layout/Header';
import HomeCardGrid from '@/components/home/HomeCardGrid';
import { useAuth } from '@/hooks/useAuth';

const Welcome = () => {
  const { user } = useAuth();
  const displayName = user?.user_metadata?.full_name || 'bạn';

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container py-6">
        <div className="space-y-8">
          <div>
            <h1 className="text-2xl font-bold text-foreground">
              Xin chào, {displayName}
            </h1>
            <p className="text-muted-foreground mt-1">
              Chọn chức năng bên dưới để bắt đầu
            </p>
          </div>
          <HomeCardGrid />
        </div>
      </main>
    </div>
  );
};

export default Welcome;
